//Menu helpers
const mainNav = document.querySelector('.nav');
const menuToggle = document.querySelector('.nav .nav__toggle');
const menuItems = document.querySelectorAll('.nav nav li.has-dd > a');
const haveDropdowns = document.querySelectorAll('.nav nav li.has-dd');
const cultureForm = document.querySelector('.formCulture form');
const menuItemsBack = document.querySelectorAll('.nav nav li.has-dd .dd__back');

if (cultureForm != null) {
    const cultureFormLinks = cultureForm.querySelectorAll('a');
    let cultureFormValue = cultureForm.querySelector('#culture');
    Array.prototype.forEach.call(cultureFormLinks, function (el, i) {
        el.addEventListener("click", function (event) {
            event.preventDefault();
            cultureFormValue.value = this.dataset.value;
            cultureForm.submit();
            return false;
        });
    });
}

if (menuToggle != null) {
    menuToggle.addEventListener('click', function (event) {
        mainNav.classList.toggle('open');
    });
}



Array.prototype.forEach.call(menuItems, function (el, i) {
    el.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
            event.preventDefault();
            return false;
        }
    });

    el.addEventListener("keyup", function (event) {
        //click event for screen readers
        //if (window.innerWidth < 1024) { //Not sure this if is needed but putting in place to protect mobile
        if (event.key === "Enter") {

            if (!this.parentNode.classList.contains("show-dd")) {
                closeDropdowns();
                this.parentNode.className = "has-dd show-dd";
                this.setAttribute('aria-expanded', "true");
            } else {
                closeDropdowns();
                this.parentNode.className = "has-dd clicked";
                this.setAttribute('aria-expanded', "false");
            }

            event.preventDefault();
            return false;

        }
    });

    el.addEventListener("click", function (event) {
        if (window.innerWidth >= 1024) {
            if (event.target.href != "" && event.target.href.indexOf("#") > 0) {
                event.preventDefault();
                return false;
            }
        } else {
            if (!this.parentNode.classList.contains("show-dd")) {
                closeDropdowns();
                this.parentNode.className = "has-dd show-dd";
                this.setAttribute('aria-expanded', "true");
            } else {
                closeDropdowns();
                this.parentNode.className = "has-dd clicked";
                this.setAttribute('aria-expanded', "false");
            }
            event.preventDefault();
            return false;
        }
    });
    el.addEventListener("mouseout", function (event) {
        //use mouse leave event to reset hover state - assume the user's not using the keyboard to navigate
        if (window.innerWidth < 1024) return;
        Array.prototype.forEach.call(haveDropdowns, function (el, i) {
            el.className = "has-dd";
        });
    });
});

Array.prototype.forEach.call(menuItemsBack, function (el, i) {
    el.addEventListener("click", function (event) {
        this.parentNode.parentNode.parentNode.classList.remove('show-dd');
        this.parentNode.parentNode.parentNode.querySelector('a').setAttribute('aria-expanded', "false");
        event.preventDefault();
        return false;
    });
});

function closeDropdowns() {
    Array.prototype.forEach.call(haveDropdowns, function (el, i) {
        el.className = "has-dd clicked";
    });
    Array.prototype.forEach.call(menuItems, function (el, i) {
        el.setAttribute('aria-expanded', "false");
    });
}

//var menuItems = document.querySelectorAll('.nav__main-menu li.has-dd');
//Array.prototype.forEach.call(menuItems, function(el, i){
//	el.querySelector('a').addEventListener("click",  function(event){
//		if (this.parentNode.className == "has-dd") {
//			this.parentNode.className = "has-dd open";
//			this.setAttribute('aria-expanded', "true");
//		} else {
//			this.parentNode.className = "has-dd";
//			this.setAttribute('aria-expanded', "false");
//		}
//		event.preventDefault();
//		return false;
//	});
//});